import styled from "styled-components";

const bp = { md: "900px" };

const c = {
  ink: "#2a1f1f",
  soft: "rgba(42,31,31,0.75)",
  gold: "#c9a227",
  page: "#ffffff",
};

export const Wrap = styled.section`
  width: 100%;
  padding: 50px 0;
  position: relative;
  isolation: isolate;
  background: transparent;
`;

export const Inner = styled.div`
  width: min(900px, calc(100% - 40px));
  margin: 0 auto;
  text-align: center;
  display: grid;
  gap: 2px;

  position: relative;
  z-index: 1; /* ✅ peste desen */
`;
export const Title = styled.h2`
  margin: 0;
  font-family: "Cormorant Garamond", serif;
  font-size: 58px;
  font-weight: 500;
  letter-spacing: 0.02em;
  color: ${c.ink};

  @media (max-width: ${bp.md}) {
    font-size: 38px;
  }
`;

export const Script = styled.div`
  font-family: "Ephesis", cursive;
  font-size: 30px;
  color: ${c.soft};
  @media (max-width: ${bp.md}) {
    font-size: 24px;
  }
`;

export const PortraitWrap = styled.div`
  display: grid;
  place-items: center;
  margin-top: 6px;
`;

/* Medalion: cerc cu inel fin + micro highlight */
export const PortraitFrame = styled.div`
  width: min(500px, 92vw); /* 🔥 mai mare */
  display: grid;
  place-items: center;
`;

export const PortraitImg = styled.img`
  width: 100%;
  height: auto;
  display: block;

  /* IMPORTANT: dacă PNG-ul are transparență și ramă rotundă,
     nu mai aplicăm border-radius sau crop. */

  /* opțional: umbră foarte fină, premium */
  filter: drop-shadow(0 12px 26px rgba(0, 0, 0, 0.16));
`;

export const GoldLine = styled.div`
  width: 70px;
  height: 1px;
  background: ${c.gold};
  margin: 16px auto 10px;
`;

export const Text = styled.p`
  margin: 0 auto;
  font-size: 20px;
  line-height: 1.9;
  color: ${c.soft};
  max-width: 72ch;
  font-family: "Cormorant Garamond", serif;

  @media (max-width: ${bp.md}) {
    line-height: 1.4;
  }
`;

export const Actions = styled.div`
  margin-top: 20px;
`;

export const PrimaryBtn = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;

  font-family: "Cormorant Garamond", serif;
  font-size: 18px;
  letter-spacing: 0.08em;
  color: ${c.gold};

  position: relative;
  padding: 6px 0;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: -4px;
    height: 1px;
    background: ${c.gold};
  }
`;
